module.exports = __webpack_public_path__ + "img/0-99.242abc12.jpg";